import React from 'react';
import styled from 'styled-components';

const ConnectionNotification = styled.div`
    background: ${props => props.connected ? 'green' : 'red' };
    padding: 10px 15px;
    border-radius: 15px;
    color: #fff;
    margin-left: 10px;
    font-size: ${props => props.theme.smallFont};
`;

export const ClientConnectedIndicator = ({ clientConnected }) => (
    <ConnectionNotification connected={clientConnected} >
        { clientConnected ? 'Client connected' : 'Client disconnected'}
    </ConnectionNotification>
);

export default ClientConnectedIndicator;
